'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionRecordVoiceOver = function ActionRecordVoiceOver(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('circle', { cx: '9', cy: '9', r: '4' }),
    _react2.default.createElement('path', { d: 'M9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm7.76-9.64l-1.68 1.69c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27zM20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14z' })
  );
};
ActionRecordVoiceOver = (0, _pure2.default)(ActionRecordVoiceOver);
ActionRecordVoiceOver.displayName = 'ActionRecordVoiceOver';
ActionRecordVoiceOver.muiName = 'SvgIcon';

exports.default = ActionRecordVoiceOver;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/action/record-voice-over.js
// module id = 1019
// module chunks = 0